import { css } from '@emotion/react';
import styled, { FunctionInterpolation } from '@emotion/styled';
import { pxToRem, Text, Theme } from '@lbcamden/lib-react';

export const rootStyles: FunctionInterpolation<Theme> = (theme) => css`
  width: 100%;

  ${theme.breakpoints.up('md')} {
    max-width: ${pxToRem(490)};
  }
`;

export const PropertyAddress = styled(Text)`
  flex: 1;
`;

export const BuildingId = styled(Text)`
  ${({ theme }) => theme.text.body2};
  align-self: center;
  padding-left: ${({ theme }) => theme.spacing(3)};
  color: ${({ theme }) => theme.colors.textSecondary};
`;
